import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'


const Contactpage = () => {

    return(
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-placeholder"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Indirizzo</h2>
                                            <p>Via Contrada Posta Cisterna, Snc
                                                Castelluccio dei Sauri (FG) 71025 </p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>

                                        <div className="office-info-text">
                                            <h2>Email</h2>
                                            <p>dtmacchine@gmail.com</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-phone-call"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Telefono</h2>
                                            <p>+39 348 722 6077</p>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div className="wpo-contact-title">
                            <h2>
                                Siamo qui per te e il tuo gatto
                            </h2>
                            <p>
                                Hai dubbi sul funzionamento o vuoi maggiori informazioni prima dell'acquisto? Scrivici, il nostro team ti risponderà in meno di 24 ore.
                            </p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm/>
                        </div>
                    </div>                
                </div>
            </div> 
            <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe title='comtact-map' src="https://maps.google.com/maps?q=Via+Contrada+Posta+Cisterna,+71025+Castelluccio+dei+Sauri+FG&output=embed" loading="lazy"></iframe>
                </div>
            </section>
        </section>
     )
        
}

export default Contactpage;
